export enum AcceptInvitationSteps {
  UserStep = 'userStep',
  Creating = 'creating',
  Finished = 'finished',
}
